import { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { MdChat } from 'react-icons/md';
import { FlexBox, Input, Button } from 'components';

const Task04 = () => {
  const [text, setText] = useState('');
  const actualText = useRef(text);

  function handleSend() {
    if (!text.trim().length) return toast.warning('Please, input message!');

    setTimeout(() => {
      toast.info(`Sending: "${actualText.current}"`);
      setText('');
    }, 3000);
  }

  return (
    <FlexBox wrapped="wrap">
      <Input
        name="messageT04"
        value={text}
        placeholder="Input message..."
        onChange={e => {
          setText(e.target.value);
          actualText.current = e.target.value;
        }}
        icon={<MdChat />}
      />
      <Button onClick={handleSend} caption="Send" />
    </FlexBox>
  );
};

export default Task04;
